import {  useEffect, useState } from "react";
import { HiSpeakerWave, HiMiniSpeakerXMark } from "react-icons/hi2"
import {  useSelector } from "react-redux";
import { retrunAssets } from "../utils/getAssets";
// import { apis } from "../api/apiUrl";
// import axios from "axios";
// import { showImage } from "../api/functions";
// import poster from '../assets/poster.svg'
// import vid from "../assets/hero.mp4"
const Hero = () => {
   const state = useSelector(state => state.homepage)

   


    const poster = '/assets/poster.svg'
    // const vid = state?.data?.properties?.introductoryVideo[0]?.url || "/assets/hero.mp4"
    const [isMute, setIsMute] = useState(true)
    const [video,setVideo ] = useState("")
    // useEffect(() => {
    //     async function fetchData() {
    //         const response = await axios.get(apis.baseUrl + apis.getHomeVideo);
    //         setVideo(showImage(response?.data.homeVideo.videoLink));
    //     }
    //     fetchData();
    // }, []);

    useEffect(() => {
        setVideo(state?.data?.properties?.introductoryVideo != null ? retrunAssets(state?.data?.properties?.introductoryVideo[0]?.url) : "")
        
    },[state?.data?.properties?.introductoryVideo, state.isLoading])
  

    return (
        <div className=" relative w-full h-screen bg-slate-200 " >
            <video src={video}  id="bgVideo" preload="none"  autoPlay loop muted={isMute} poster={poster} className="fixed w-full h-full inset-0 object-cover aspect-square ">
                    <track kind="captions"></track>
                </video>
          
            <div className="fixed bottom-16 2xl:bottom-28 2xl:right-10 2xl:w-12 2xl:h-12 right-5 bg-black/40 p-3 rounded-lg cursor-pointer text-white " onClick={() => setIsMute(prev => !prev)}>
                {
                    isMute ? <HiMiniSpeakerXMark size={25} /> : <HiSpeakerWave size={25} />
                }

            </div>
        </div>
    )
}

export default Hero